import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useTheme } from '@mui/material/styles';

import { useGetProgramSets } from '../../../redux/api/programsAPI';
import { IProgramSet } from '../../../types/interfaces/program-set';
import { orderBy } from '../../../utils/collections/array-utils';
import { AppBarWithButtons } from '../../designe/app-bars/app-bar-with-action-buttons/AppBarWithButtons';
import AppChipSelector from '../../designe/app-chip-selector';
import AppSwitchWithLabel from '../../designe/app-switch-with-label/AppSwitchWithLabel';
import { useStyles } from './SavedProgramSetSuperset.style';

interface ISavedProgramSetProps {
  onCancel: () => void;
  onSubmitSavedProgramSet: (v: {
    programSets: IProgramSet[];
    isSuperset: boolean;
  }) => void;
}

export default function SavedProgramSetSuperset(props: ISavedProgramSetProps) {
  const { onCancel, onSubmitSavedProgramSet } = props;
  const [isSuperset, setIsSuperset] = useState(null);
  const { data: programSets } = useGetProgramSets();
  const { t } = useTranslation();
  const theme = useTheme();

  const { classes } = useStyles(theme);
  const [selectedProgramSets, setSelectedProgramSets] = useState([]);

  const sortedProgramSets = orderBy(programSets, 'title');

  return (
    <div className={classes.savedProgramSetWrapper}>
      <AppSwitchWithLabel
        onChange={(event) => setIsSuperset(event.target.checked)}
        label={t('programs.superset')}
        value={isSuperset}
        className={classes.supersetSwitch}
      />
      <AppChipSelector
        options={[...sortedProgramSets]}
        values={selectedProgramSets}
        fieldName={'title'}
        label={t('programs.savedProgramSet')}
        onChange={(e) => {
          setSelectedProgramSets(e);
        }}
      />

      <div className={classes.savedProgramSetBottom}>
        <AppBarWithButtons
          disabled={!selectedProgramSets?.length}
          onClick={() => {
            onSubmitSavedProgramSet({
              programSets: selectedProgramSets,
              isSuperset,
            });
          }}
          onCancelClick={onCancel}
        />
      </div>
    </div>
  );
}
